import settings from '@/libs/constant/settings'
import {verifyShareSource, claimRequestConfirmation} from '@/libs/api/api'
export default {
    name: 'shareSourceConfirmation',
    beforeMount () {
        let language = localStorage.getItem('lang')
        this.$i18n.locale = language || settings.LOCIZE.LANGUAGE.ENGLISH_GB
        this.message = window.i18next.t('Please wait, connecting...')
        if (this.$route.name === 'source-confirmation') {
            this.getShareSourceConfirmation()
        }
        else if (this.$route.name === 'claim-request-confirmation') {
            this.getClaimRequestConfirm()
        }
    },
    data() {
        return {
            message: ''
        }
    },
    methods: {
        getIcon () {
            return require('@/assets/images/Accura logo design_Web_blue.svg')
        },
        getShareSourceConfirmation () {
            this.message
            let id = this.$route.query.id || ''
            let type = this.$route.query.type || ''
            let key = this.$route.query.key || ''
            let body = {
                id, type, key
            }
            verifyShareSource(body).then(response => {
                if(type == 1){
                    this.message = `${window.i18next.t(response.message)} ${window.i18next.t('Close this window and re-start your application to see the new content.')}`
                }else if(type == 0 || type == 2) {
                    this.message = window.i18next.t(response.message)
                }
            }).catch(error => {
                this.message = window.i18next.t(error.message)
            })
        },
        getClaimRequestConfirm () {
            let body = {
                action: this.$route.query.action,
                uniqueId: this.$route.query.uniqueId,
                entityId: this.$route.query.entityId
            }
            claimRequestConfirmation(body).then(response => {
                this.message = `${window.i18next.t(response.message)} ${window.i18next.t('Close this window, and refresh the Accura web portal to see the changes.')}`
            }).catch(error => {
                this.message = window.i18next.t(error.message)
            })
        }
    }
}